export const DEFAULT_CRM_TOKEN = '3ze0aplhlpi';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const submitRequestIconUrl = `${window.assetsLocation}/images/request.svg`;
export const loginRequestsIconUrl = `${window.assetsLocation}/images/inbox.svg`;
export const viewAllRequestsIconUrl = `${window.assetsLocation}/images/map.svg`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['17'];
export const faqArticleIds = ['3', '4', '5', '6', '7', '8', '10'];
